/* eslint-disable */

import React, { ReactNode } from 'react';

import './FieldGroup.scss';

type Props = {
  className?: string;
  description?: string;
  labelClassName?: string;
  required?: boolean;
  labelRequired?: string;
  labelMuted?: boolean;
  label: string;
  children?: ReactNode;
  labelOption?: string;
};

function FieldGroup({
  className = '',
  labelClassName = '',
  description = '',
  required = false,
  labelMuted = false,
  label,
  labelRequired = '*',
  children,
  labelOption,
}: Props) {
  return (
    <div className={`form-field ${className}`}>
      <div className="form-field-label">
        <div className={`d-flex ${labelClassName} ${labelMuted ? 'form-field-label--muted' : ''}`}>
          {label}
          {required ? <span className="text-danger mx-1">{labelRequired}</span> : null}
        </div>
        {description && <div className="form-field-label-description mb-3">{description}</div>}
        {labelOption && <em className="form-field-label-option ml-1">{labelOption}</em>}
      </div>
      {children}
    </div>
  );
}

export default FieldGroup;
